import { getDate } from '@utils/dates';
import { wordsToSentence } from '@utils/textHelper';

const creators = (authors) => {
  if (Array.isArray(authors)) {
    return authors.map((author) => ({
      '@type': 'Person',
      name: author.name || `${author.firstName} ${author.lastName}`
    }));
  }
  return { '@type': 'Person', name: authors.name };
};

function courseSchema(course) {
  const {
    thumbnail,
    topic,
    name,
    authors,
    author,
    description,
    permalink,
    forPlus,
    goal = {},
    coverPhoto,
    uid,
    language,
    languages
  } = course;
  if (!goal) return null;
  const authorInfo = authors ? authors[0] : author ?? {};
  return {
    '@context': 'https://schema.org/',
    '@type': 'Course',
    image: coverPhoto || thumbnail,
    courseCode: uid,
    accessMode: ['auditory', 'visual'],
    url: permalink,
    thumbnailUrl: coverPhoto || thumbnail,
    provider: {
      '@type': 'Organization',
      name:
        authorInfo?.name || `${authorInfo?.firstName} ${authorInfo?.lastName}`,
      sameAs: `https://unacademy.com/@${authorInfo?.username}`
    },
    about: { name: topic },
    audience: {
      audienceType: [`Anyone Prepearing for ${goal.name}`],
      '@type': 'Audience'
    },
    name,
    inLanguage: language || wordsToSentence(languages, 'label', ', ', ', '),
    publisher: {
      '@type': 'Organization',
      name: 'Unacademy',
      sameAs: 'https://unacademy.com/'
    },
    description: (description || '').replace(/</g, '< ').replace(/>/g, ' >'),
    '@id': permalink,
    creator: creators(authors || author),
    isAccessibleForFree: forPlus
      ? 'http://schema.org/False'
      : 'http://schema.org/True',
    hasCourseInstance: [
      {
        '@type': 'CourseInstance',
        courseMode: ['Online', 'Distance Learning'],
        startDate: getDate(course.startsAt)
      }
    ]
  };
}

export default courseSchema;
